































































































































































































































































































































































































































import draggable from "vuedraggable";
import { EventBus } from "@/event-bus.js";
import MachinesModal from "@/components/MachinesModal.vue";

import Rtc from "@/rtc";

import {
  getChecklist,
  getAllComponents,
  getMessageFormats,
  getComponent,
  getTask,
  getQuestion,
  getAnswer,
  createItem,
  updateItem,
  deleteItem,
  duplicateItem,
  sortItems,
  translateField,
  genPostReq,
} from "@/services/checklist.service";
import ClComponents from "@/components/checklist/ClComponents.vue";
import ClComponent from "@/components/checklist/ClComponent.vue";
import ClTask from "@/components/checklist/ClTask.vue";
import ClQuestion from "@/components/checklist/ClQuestion.vue";

export default {
  watch: {
    $route(to, from) {
      //console.log("route change", to, from)
    },
  },
  data() {
    return {
      treeData: [],
      activeTreeRow: {},
      loading_search: false,
      searchContentHeight: 0,
      switch1: true,
      open: [1, 2],
      search_keyword: null,
      search: null,
      caseSensitive: false,
      items: [
        {
          id: 1,
          name: "Applications :",
          children: [
            { id: 2, name: "Calendar : app" },
            { id: 3, name: "Chrome : app" },
            { id: 4, name: "Webstorm : app" },
          ],
        },
      ],
      na1: false,
      np1: false,
      tabs: null,
      filter1: null,
      tree: [],
      value: null,

      formProjectId: "",
      error: false,
      success: false,

      initLoaded: true,

      prueferg: null,

      // ----
      answer_dialog: false,
      create_dialog: false,
      sort_dialog: false,
      create_progress: false,
      showComponent: false,
      showComponents: false,
      componentLoaded: false,
      showTask: false,
      taskLoaded: false,
      showQuestion: false,
      questionLoaded: false,
      showAnswer: false,
      answerLoaded: false,
      showSearchResult: false,
      itemsState: [
        { text: "-" },
        { text: this.$t("LABEL92"), value: "NT" },
        { text: this.$t("LABEL61"), value: "V" },
        { text: this.$t("LABEL62"), value: "I" },
        { text: this.$t("LABEL63"), value: "E" },
        { text: this.$t("LABEL64"), value: "P" },
        { text: this.$t("LABEL65"), value: "PP" },
        { text: this.$t("LABEL66"), value: "PPP" },
      ],
      comp_state: 0,
      create_entry: {},
      sort_entry: {},
      create_error: false,
      answer_entry: {},
      org_answer_entry: {},
      snackbar: false,
      snackbar_text: "",
      delete_dialog: false,
      delete_progress: false,
      delete_entry: {},
      answer_confirm: false,
      sort_progress: false,
      sort_items: [],
      showMachines: false,
      org_answer_machines: [],
      field_message_name_en: [],
      field_message_recommendation_en: [],
      field_message_instruction_en: [],
      field_message_result_en: [],

      field_message_name_fr: [],
      field_message_recommendation_fr: [],
      field_message_instruction_fr: [],
      field_message_result_fr: [],

      sel_addmachines: [],
      sel_machinesingroup: [],
      sel_removemachines: [],

      selected_search: [2],
      items_search: [],
    };
  },
  components: {
    draggable,
    ClComponents,
    ClComponent,
    ClTask,
    ClQuestion,
    MachinesModal,
  },
  methods: {
    isNumber(evt: KeyboardEvent): void {
      const keysAllowed: string[] = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '.'];
      const keyPressed: string = evt.key;

      if (!keysAllowed.includes(keyPressed)) {
        evt.preventDefault()
      }
    },
    updateInformElement: function (d) {
      console.log("updateInformElement", d);
    },
    inspectionToTree(tree_item, inspection, k) {
      if (inspection.components && inspection.components.length > 0) {
        for (var i = 0; i < inspection.components.length; i++) {
          k++;
          let item = {
            name: inspection.components[i].name.de,
            parent_id: inspection.components[i].parent_id,
            id: k + "_" + inspection.components[i]._id,
            children: [],
          };
          this.inspectionToTree(item.children, inspection.components[i], k);
          tree_item.push(item);
        }
      }

      this.activeTreeRow = [this.treeData[0]];
    },
    openTreeItem(item) {
      this.tasks = [];
      var ref = this;
      console.log(item);
      if (item && item[0]) {
        //this.selectedComponent = item[0]
      }
    },
    getComponentTree: function () {
      genPostReq("checklist", "component-tree", {
        cl_uid: this.$store.state.cl_uid,
      }).then((resp) => {
        this.treeData = [];
        this.inspectionToTree(this.treeData, resp.data.components, 0);
      });
    },
    resetSearchFilter: function () {
      this.search_keyword = "";
      this.items_search = [];
    },
    checklistSearch: function () {
      if (!this.search_keyword || this.search_keyword.length < 3) {
        return;
      }
      0;
      this.loading_search = true;
      genPostReq("checklist", "search", {
        cl_uid: this.$store.state.cl_uid,
        search_keyword: this.search_keyword,
      }).then((resp) => {
        console.log("checklist : search", resp.data);

        this.items_search = [];

        this.loading_search = false;

        if (
          resp.data.component_entries &&
          resp.data.component_entries.length > 0
        ) {
          for (let k of Object.values(resp.data.component_entries)) {
            let lsstr = [];
            for (let x of k["comp_list"]) {
              lsstr.push(x.name);
            }
            this.items_search.push({
              type: "comp",
              entry: k,
              title: k["name"],
              subline: lsstr.join(" > "),
            });
          }
        }

        if (resp.data.task_entries && resp.data.task_entries.length > 0) {
          for (let k of Object.values(resp.data.task_entries)) {
            let lsstr = [];
            for (let x of k["comp_list"]) {
              lsstr.push(x.name);
            }
            this.items_search.push({
              type: "task",
              entry: k,
              title: k["name"],
              subline: lsstr.join(" > "),
            });
          }
        }

        if (
          resp.data.formfields_entries &&
          resp.data.formfields_entries.length > 0
        ) {
          for (let k of Object.values(resp.data.formfields_entries)) {
            let lsstr = [];
            for (let x of k["comp_list"]) {
              lsstr.push(x.name);
            }
            this.items_search.push({
              task_name: k["task_name"],
              type: "formfield",
              entry: k,
              title: k["name"],
              subline: lsstr.join(" > "),
            });
          }
        }
      });
    },
    closeSearch: function (val) {
      this.searchDrawer = false;
    },
    setAnswerState: function (val) {
      if (this.answer_entry.taskState == val) {
        this.answer_entry.taskState = "";
      } else {
        this.answer_entry.taskState = val;
      }
    },
    rowclick: function (item) {
      for (let i of this.items) {
        i.active = i == item;
      }
    },
    selectSearchResult(item, type) {
      this.$store.state.cl_component_map = [""];

      if (type == "comp") {
        if (item.comp_list.length > 0) {
          for (let k of item.comp_list) {
            this.$store.state.cl_component_map.push(k.uid);
          }
        }
        this.$store.state.cl_component_map.push(item.uid);
      }

      if (type == "task") {
        if (item.comp_list.length > 0) {
          for (let k of item.comp_list) {
            this.$store.state.cl_component_map.push(k.uid);
          }
        }
        this.$store.state.cl_task_uid = item.uid;
      }

      if (type == "formfield") {
        if (item.comp_list.length > 0) {
          for (let k of item.comp_list) {
            this.$store.state.cl_component_map.push(k.uid);
          }
        }
        this.$store.state.cl_task_uid = item.task_uid;
        this.$store.state.cl_question_uid = item.uid;
      }

      console.log(
        "this.$store.state.cl_component_map ",
        this.$store.state.cl_component_map
      );
      this.$store.commit("set_selected_route");
      this.$store.state.initParams = { ...this.$route.params };
      EventBus.$emit("path_changed", {});
    },
    /*
    toggle() {
      this.$nextTick(() => {
        if (this.likesAllFruit) {
          this.selectedFruits = [];
        } else {
          this.selectedFruits = this.fruits.slice();
        }
      });
    },
    */
    selectCmp(data) {
      this.$store.state.cl_component_uid = data.cmp_uid;
      this.$store.state.cl_component = null;
      this.componentLoaded = false;
      this.showComponent = true;
      this.showTask = false;
      this.showQuestion = false;
      this.$store.state.cl_component_level = data.level;

      this.$store.commit("select_comp", {
        level: data.level,
        uid: data.cmp_uid,
      });

      if (!data.deeplink) {
        this.$store.commit("set_selected_route");
      }

      /*
      if (data.level == 1) {
       
        genPostReq('checklist', 'checklist-tree', { cl_uid: this.$store.state.cl_uid, comp_uid: data.cmp_uid })
        .then(resp => {
          console.log("resp", resp) 
        })
        .catch(e => {
          this.$store.dispatch("api_error", e);
        }); 

      }
      */

      getComponent(this.$store.state.cl_uid, data.cmp_uid, data.level)
        .then((resp) => {
          //console.log("selectCmp getComponent", resp);
          this.showComponent = true;
          if (resp.status == "success") {
            if (resp.data.level == 1) {
              this.$store.state.cl_components_2 =
                resp.data.details.children_list;
              this.$store.state.cl_components_3 = [];
              this.$store.state.cl_components_4 = [];
              this.$store.state.cl_components_5 = [];
              this.$store.state.cl_components_6 = [];
              this.comp_state = 1;
            } else if (resp.data.level == 2) {
              this.$store.state.cl_components_3 =
                resp.data.details.children_list;
              this.$store.state.cl_components_4 = [];
              this.$store.state.cl_components_5 = [];
              this.$store.state.cl_components_6 = [];
              this.comp_state = 2;
            } else if (resp.data.level == 3) {
              this.comp_state = 3;
              this.$store.state.cl_components_4 =
                resp.data.details.children_list;
              this.$store.state.cl_components_5 = [];
              this.$store.state.cl_components_6 = [];
            } else if (resp.data.level == 4) {
              this.comp_state = 4;
              this.$store.state.cl_components_5 =
                resp.data.details.children_list;
              this.$store.state.cl_components_6 = [];
            } else if (resp.data.level == 5) {
              this.comp_state = 5;
              this.$store.state.cl_components_6 =
                resp.data.details.children_list;
            }

            this.$store.state.cl_component = resp.data.component;

            this.$store.state.cl_task_list = resp.data.details.task_list;
            //console.log("data", resp.data.component, resp.data.details.children_list, resp.data.details.task_list);
            this.componentLoaded = true;

            EventBus.$emit("comps_changed", { level: resp.data.level });
            EventBus.$emit("comp_changed", { level: resp.data.level });
          }
        })
        .catch((e) => {
          this.$store.dispatch("api_error", e);
        });
    },
    selectTask(uid) {
      //console.log("selectTask", uid)
      this.showTask = true;
      this.taskLoaded = false;
      this.showQuestion = false;
      this.$store.state.cl_task_uid = uid;

      this.$store.commit("set_selected_route");

      getTask(this.$store.state.cl_uid, uid)
        .then((resp) => {
          if (resp.status == "success") {
            this.$store.state.cl_task = resp.data.task;
            this.$store.state.cl_question_list =
              resp.data.details.question_list;
            this.taskLoaded = true;
            EventBus.$emit("task_changed", {});
          }
        })
        .catch((e) => {
          this.$store.dispatch("api_error", e);
        });
    },
    selectQuestion(uid) {
      //console.log("selectQuestion", uid)
      this.showQuestion = true;
      this.$store.state.cl_question_uid = uid;

      this.$store.commit("set_selected_route");

      getQuestion(this.$store.state.cl_uid, uid)
        .then((resp) => {
          if (resp.status == "success") {
            this.$store.state.cl_question = resp.data.question;
            this.$store.state.cl_answer_list = resp.data.details.answer_list;
            this.questionLoaded = true;
            EventBus.$emit("question_changed", {});
          }
        })
        .catch((e) => {
          this.$store.dispatch("api_error", e);
        });
    },
    selectAnswer(item) {
      console.log("selectAnswer", item.value);
      this.answerLoaded = false;
      this.answer_dialog = true;
      getAnswer(this.$store.state.cl_uid, item.value)
        .then((resp) => {
          if (resp.data.entry) {
            if (!resp.data.entry.machinegroup_list) {
              resp.data.entry.machinegroup_list = [];
            }

            if (resp.data.entry.machinegroup) {
              if (!resp.data.entry.machinegroup_created) {
                resp.data.entry.machinegroup_created = true;
                resp.data.entry.machinegroup_list = [
                  resp.data.entry.machinegroup,
                ];
              }
            }

            if (resp.data.entry && !resp.data.entry.machinegroup_list) {
              resp.data.entry.machinegroup_list = [];
              if (resp.data.entry.machinegroup) {
                resp.data.entry.machinegroup_list.push(
                  resp.data.entry.machinegroup
                );
              }
            }

            resp.data.entry.machinegroup_created = true;
          }

          this.answer_entry = resp.data.entry;

          this.org_answer_entry = { ...resp.data.entry };

          resp.data.entry.lang_switch = resp.data.entry.lang_switch == "true";

          this.org_answer_machines = JSON.parse(
            JSON.stringify(resp.data.entry.machines)
          );
          this.answerLoaded = true;
        })
        .catch((e) => {
          this.$store.dispatch("api_error", e);
        });
    },
    deleteAnswer() {
      this.answer_entry.type = "answer";
      this.answerLoaded = false;
      this.answer_confirm = false;
      deleteItem(this.answer_entry)
        .then((resp) => {
          console.log("deleteItem", resp);
          if (resp.status == "success") {
            this.snackbar = true;
            this.answer_dialog = false;
            if (resp.type == "answer") {
              this.snackbar_text = this.$t("LABEL98");
              this.$store.state.cl_answer_list = resp.list;
            }

            this.delete_dialog = false;
          }
        })
        .catch((e) => {
          this.$store.dispatch("api_error", e);
        });
      //this.answer_entry.type = "answer"
      //this.updateAct(this.answer_entry)
    },
    saveAnswer() {
      this.answer_entry.type = "answer";
      this.answer_entry.user_uid = this.$store.state.userId;
      this.answer_entry.created_at = Date.now();

      let check1 = { ...this.org_answer_entry };
      let check2 = { ...this.answer_entry };
      delete check1.created_at;
      delete check2.created_at;
      delete check1.user_uid;
      delete check2.user_uid;
      delete check1.type;
      delete check2.type;

      if (
        JSON.stringify(check1) != JSON.stringify(check2) ||
        this.answer_entry.machines.length != this.org_answer_machines.length
      ) {
        this.org_entry = { ...this.answer_entry };
        this.updateAct(this.answer_entry);
        EventBus.$emit("updateInformElement", {
          type: "options",
          uid: this.answer_entry.uid,
        });
      } else {
        this.updateAct({ no_changes: true });
      }
    },
    saveNew() {
      this.create_error = this.create_entry.name.length <= 1;

      if (this.create_entry.name.length > 1) {
        this.create_progress = true;
        createItem(this.create_entry)
          .then((resp) => {
            if (resp.status == "success") {
              this.create_dialog = false;
              this.create_progress = false;
              this.snackbar = true;

              if (resp.type == "component") {
                if (resp.level == 1) {
                  // Hauptkomponente
                  this.$store.commit("cl_components", resp.data.list);
                }
                this.snackbar_text = this.$t("LABEL99");
                this.bc.postMessage({
                  type: "RELOAD_TREE",
                  cl_uid: this.$store.state.cl_uid,
                });
              } else if (resp.type == "task") {
                this.$store.state.cl_task_list = resp.data.list;
                //console.log(resp.list[resp.list.length-1].value)
                this.snackbar_text = this.$t("LABEL100");
              } else if (resp.type == "question") {
                this.$store.state.cl_question_list = resp.data.list;
                //console.log(resp.list[resp.list.length-1].value)
                this.snackbar_text = this.$t("LABEL101");
              } else if (resp.type == "answer") {
                this.$store.state.cl_answer_list = resp.data.list;
                //console.log(resp.list[resp.list.length-1].value)
                this.snackbar_text = this.$t("LABEL103");
                EventBus.$emit("updateInformElement", {
                  type: "answer",
                  uid: resp.data.entry_uid,
                });
              } else if (resp.type == "subcomponent") {
                this.bc.postMessage({
                  type: "RELOAD_TREE",
                  cl_uid: this.$store.state.cl_uid,
                });
                if (resp.level == 1) {
                  this.$store.state.cl_components_2 = resp.data.list;
                  this.$store.state.cl_components_3 = [];
                  this.$store.state.cl_components_4 = [];
                  this.$store.state.cl_components_5 = [];
                }
                if (resp.level == 2) {
                  this.$store.state.cl_components_3 = resp.data.list;
                  this.$store.state.cl_components_4 = [];
                  this.$store.state.cl_components_5 = [];
                }
                if (resp.level == 3) {
                  this.$store.state.cl_components_4 = resp.data.list;
                  this.$store.state.cl_components_5 = [];
                }
                if (resp.level == 4) {
                  this.$store.state.cl_components_5 = resp.data.list;
                }
                this.snackbar_text = this.$t("LABEL102");
              }
              //console.log(resp)
              console.log("saved", resp);
              EventBus.$emit("entry_added", {
                create: true,
                entry_uid: resp.data.entry_uid,
                type: resp.type,
                level: resp.level,
              });
            }
          })
          .catch((e) => {
            this.$store.dispatch("api_error", e);
          });
      }
    },
    sortAct(d) {
      console.log("sortAct", d);
      this.sort_progress = false;
      this.sort_dialog = true;
      if (d.type == "component") {
        d.headline = this.$t("COMPONENTS");
        this.sort_items = this.$store.state.cl_components;
      }
      if (d.type == "task") {
        d.headline = this.$t("TASK");
        this.sort_items = this.$store.state.cl_task_list;
      }
      if (d.type == "subcomponent") {
        d.headline = this.$t("SUBOMPONENT");
        if (d.level == 1) {
          this.sort_items = this.$store.state.cl_components_2;
        }
        if (d.level == 2) {
          this.sort_items = this.$store.state.cl_components_3;
        }
        if (d.level == 3) {
          this.sort_items = this.$store.state.cl_components_4;
        }
      }
      if (d.type == "question") {
        d.headline = this.$t("CHECKPOINT");
        this.sort_items = this.$store.state.cl_question_list;
      }

      this.sort_entry = {
        headline: d.headline,
        type: d.type,
        level: d.level,
        cl_uid: this.$store.state.cl_uid,
      };
    },
    copyAct(d) {
      console.log("copyAct", d);
      this.$store.state.copy_entry = d;
      this.bc.postMessage({
        type: "COPY_ENTRY",
        cl_uid: this.$store.state.cl_uid,
        entry: d,
      });
    },
    pasteAct(d) {
      console.log(
        "paste",
        this.$store.state.copy_entry,
        this.$store.state.cl_component
      );

      console.log(
        "type",
        this.$store.state.copy_entry.type,
        "target_cl_uid",
        this.$store.state.cl_uid,
        "cl_uid",
        this.$store.state.copy_entry.cl_uid,
        "entry_uid",
        this.$store.state.copy_entry.uid,
        "level",
        this.$store.state.copy_entry.level,
        "task_uid",
        this.$store.state.cl_task_uid,
        "target_parent_uid",
        this.$store.state.cl_component &&
          this.$store.state.cl_component.parent_id
          ? this.$store.state.cl_component.parent_id
          : "",
        "component_uid",
        this.$store.state.cl_component_uid
      );

      genPostReq("checklist", "duplicate-entry", {
        type: this.$store.state.copy_entry.type,
        target_cl_uid: this.$store.state.cl_uid,
        cl_uid: this.$store.state.copy_entry.cl_uid,
        entry_uid: this.$store.state.copy_entry.uid,
        level: this.$store.state.copy_entry.level,
        task_uid: this.$store.state.cl_task_uid,
        target_parent_uid:
          this.$store.state.cl_component &&
            this.$store.state.cl_component.parent_id
            ? this.$store.state.cl_component.parent_id
            : "",
        component_uid: this.$store.state.cl_component_uid,
      })
        .then((resp) => {
          console.log("resp", resp);
          this.$store.state.copy_entry = null;

          if (resp.status == "success") {
            console.log("pasteAct", resp.data);
            if (resp.data.data.type == "question") {
              // Prüfpunkt
              this.$store.state.cl_question_list = resp.data.data.list;
              this.snackbar_text = this.$t("LABEL104");
            } else if (resp.data.data.type == "task") {
              // Aufgabe
              this.$store.state.cl_task_list = resp.data.data.list;
              this.snackbar_text = this.$t("LABEL105");
            } else if (resp.data.data.type == "component") {
              // Komponente
              this.snackbar_text = this.$t("LABEL106");
              this.bc.postMessage({
                type: "RELOAD_TREE",
                cl_uid: this.$store.state.cl_uid,
              });
              if (resp.data.data.level == 1) {
                this.$store.state.cl_components = resp.data.data.children_list;
                this.$store.state.cl_components_2 =
                  this.$store.state.cl_components_3 =
                  this.$store.state.cl_components_4 =
                  this.$store.state.cl_components_5 =
                  [];
              } else if (resp.data.data.level == 2) {
                this.$store.state.cl_components_2 =
                  resp.data.data.children_list;
                this.$store.state.cl_components_3 =
                  this.$store.state.cl_components_4 =
                  this.$store.state.cl_components_5 =
                  [];
                this.comp_state = 2;
              } else if (resp.data.data.level == 3) {
                this.$store.state.cl_components_3 =
                  resp.data.data.children_list;
                this.$store.state.cl_components_4 =
                  this.$store.state.cl_components_5 = [];
                this.comp_state = 3;
              } else if (resp.data.data.level == 4) {
                this.comp_state = 4;
                this.$store.state.cl_components_4 =
                  resp.data.data.children_list;
                this.$store.state.cl_components_5 = [];
              } else if (resp.data.data.level == 5) {
                this.comp_state = 5;
                this.$store.state.cl_components_5 =
                  resp.data.data.children_list;
              }
              //this.$store.state.cl_component = resp.data.data.component;

              //this.$store.state.cl_task_list = resp.data.data.list;
              //this.snackbar_text = "Aufgabe eingefügt.";
            }

            this.snackbar = true;
            EventBus.$emit("entry_added", {
              entry_uid: resp.data.data.entry_uid,
              type: resp.data.data.type,
              level: resp.data.data.level,
            });
          }
        })
        .catch((e) => {
          this.$store.dispatch("api_error", e);
        });
    },
    duplicateAct(data) {
      var dd = {
        type: "answer",
        d: {
          uid: data.item.value,
          cl_uid: data.item.cl_uid,
        },
      };

      if (data.item.paste_cl_uid) {
        dd.d["paste_cl_uid"] = data.item.paste_cl_uid;
      }

      if (data.item.paste_question_uid) {
        dd.d["paste_question_uid"] = data.item.paste_question_uid;
      }

      duplicateItem(dd).then((resp) => {
        this.$store.state.cl_answer_list = resp.list.list;
      });
    },
    deleteAct(d) {
      this.delete_progress = false;
      this.delete_entry = d;
      this.delete_dialog = true;
    },
    deleteAction() {
      this.delete_progress = true;
      console.log("deleteAction", this.delete_entry);
      deleteItem(this.delete_entry)
        .then((resp) => {
          console.log("deleteItem", resp);
          if (resp.status == "success") {
            this.snackbar = true;
            if (resp.type == "component") {
              this.snackbar_text = this.$t("LABEL107");
              this.bc.postMessage({
                type: "RELOAD_TREE",
                cl_uid: this.$store.state.cl_uid,
              });
              this.$store.commit("cl_components", resp.list);
              this.$store.state.cl_components_2 =
                this.$store.state.cl_components_3 =
                this.$store.state.cl_components_4 =
                this.$store.state.cl_components_5 =
                [];
              EventBus.$emit("component_closed", {});
            }
            if (resp.type == "task") {
              this.snackbar_text = this.$t("LABEL108");
              this.$store.state.cl_task_list = resp.list;
              EventBus.$emit("task_closed", {});
            }
            if (resp.type == "subcomponent") {
              this.snackbar_text = this.$t("LABEL109");
              this.bc.postMessage({
                type: "RELOAD_TREE",
                cl_uid: this.$store.state.cl_uid,
              });
              if (resp.level == 2) {
                this.$store.state.cl_components_2 = resp.list;
                this.$store.state.cl_components_3 =
                  this.$store.state.cl_components_4 =
                  this.$store.state.cl_components_5 =
                  [];
              }
              if (resp.level == 3) {
                this.$store.state.cl_components_3 = resp.list;
                this.$store.state.cl_components_4 =
                  this.$store.state.cl_components_5 = [];
              }
              if (resp.level == 4) {
                this.$store.state.cl_components_4 = resp.list;
                this.$store.state.cl_components_5 = [];
              }
              if (resp.level == 5) {
                this.$store.state.cl_components_5 = resp.list;
              }
              EventBus.$emit("component_closed", {});
            }
            if (resp.type == "question") {
              this.snackbar_text = this.$t("LABEL110");
              this.$store.state.cl_question_list = resp.list;
              EventBus.$emit("question_closed", {});
            }
            if (resp.type == "answer") {
              this.snackbar_text = this.$t("LABEL111");
              this.$store.state.cl_answer_list = resp.list;
            }

            this.delete_dialog = false;
          }
        })
        .catch((e) => {
          this.$store.dispatch("api_error", e);
        });
    },
    updateAct(d) {
      if (d.no_changes) {
        this.snackbar = true;
        this.snackbar_text = this.$t("LABEL112");
        return;
      }

      //console.log("updateAct", d);
      this.$store.state.saving = true;
      this.$store.state.saving_type = d.type;
      updateItem(d)
        .then((resp) => {
          this.$store.state.saving = false;
          console.log("updateAct", resp);
          if (resp.status == "success") {
            this.snackbar = true;
            if (resp.type == "component") {
              this.snackbar_text = this.$t("LABEL113");
              this.$store.commit("cl_components", resp.list);
              this.bc.postMessage({
                type: "RELOAD_TREE",
                cl_uid: this.$store.state.cl_uid,
              });
            }
            if (resp.type == "task") {
              this.snackbar_text = this.$t("LABEL114");
              this.$store.state.cl_task_list = resp.list;
            }
            if (resp.type == "question") {
              this.snackbar_text = this.$t("LABEL115");
              this.$store.state.cl_question_list = resp.list;
            }
            if (resp.type == "answer") {
              this.snackbar_text = this.$t("LABEL116");
              this.answer_dialog = false;
              this.$store.state.cl_answer_list = resp.list;
            }

            if (resp.type == "subcomponent") {
              this.bc.postMessage({
                type: "RELOAD_TREE",
                cl_uid: this.$store.state.cl_uid,
              });
              if (resp.level == 2) {
                this.$store.state.cl_components_2 = resp.list;
                this.$store.state.cl_components_3 = [];
                this.$store.state.cl_components_4 = [];
                this.$store.state.cl_components_5 = [];
              }
              if (resp.level == 3) {
                this.$store.state.cl_components_3 = resp.list;
                this.$store.state.cl_components_4 = [];
                this.$store.state.cl_components_5 = [];
              }
              if (resp.level == 4) {
                this.$store.state.cl_components_4 = resp.list;
                this.$store.state.cl_components_5 = [];
              }
              if (resp.level == 5) {
                this.$store.state.cl_components_5 = resp.list;
              }
              this.snackbar_text = this.$t("LABEL117");
            }
          }
        })
        .catch((e) => {
          this.$store.dispatch("api_error", e);
        });
    },
    createAct(d) {
      this.create_dialog = true;
      this.create_error = false;

      setTimeout(
        function () {
          this.$refs.create_name.focus();
        }.bind(this),
        300
      );

      if (d.type == "component") {
        d.headline = this.$t("COMPONENT");
      }
      if (d.type == "task") {
        d.headline = this.$t("TASK");
      }
      if (d.type == "subcomponent") {
        d.headline = this.$t("SUBCOMPONENT");
      }
      if (d.type == "question") {
        d.headline = this.$t("CHECKPOINT");
      }
      if (d.type == "answer") {
        d.headline = this.$t("RESULT");
      }

      this.create_entry = {
        cl_uid: this.$store.state.cl_uid,
        comp_state: this.comp_state,
        task_uid: this.$store.state.cl_task_uid,
        comp_uid: this.$store.state.cl_component_uid,
        question_uid: this.$store.state.cl_question_uid,
        level: d.level ? d.level : this.$store.state.cl_component_level,
        headline: d.headline,
        type: d.type,
        name: "",
        name_en: "",
      };
      //console.log("createAct", this.create_entry);
    },
    saveSort() {
      this.sort_progress = true;

      sortItems(this.sort_items, this.sort_entry)
        .then((resp) => {
          //console.log("sortItems", resp)
          if (resp.status == "success") {
            this.snackbar = true;
            this.sort_dialog = false;
            this.sort_progress = false;
            if (resp.type == "task") {
              this.$store.state.cl_task_list = this.sort_items;
              this.snackbar_text = this.$t("LABEL118");
            }
            if (resp.type == "component") {
              this.$store.state.cl_components = this.sort_items;
              this.snackbar_text = this.$t("LABEL119");
              this.bc.postMessage({
                type: "RELOAD_TREE",
                cl_uid: this.$store.state.cl_uid,
              });
            }
            if (resp.type == "question") {
              this.$store.state.cl_question_list = this.sort_items;
              this.snackbar_text = this.$t("LABEL120");
            }
            if (resp.type == "subcomponent") {
              this.snackbar_text = this.$t("LABEL121");
              this.bc.postMessage({
                type: "RELOAD_TREE",
                cl_uid: this.$store.state.cl_uid,
              });
              if (resp.level == 1) {
                this.$store.state.cl_components_2 = this.sort_items;
              }
              if (resp.level == 2) {
                this.$store.state.cl_components_3 = this.sort_items;
              }
              if (resp.level == 3) {
                this.$store.state.cl_components_4 = this.sort_items;
              }
            }
          }
        })
        .catch((e) => {
          this.$store.dispatch("api_error", e);
        });
    },
    componentClosedHandler: function (entry) {
      this.showComponent = false;
      this.showTask = false;
      this.showQuestion = false;
      this.$store.state.cl_task_uid = null;
      this.$store.state.cl_question_uid = null;
      this.$store.commit("set_selected_route");
    },
    taskClosedHandler: function (entry) {
      this.showTask = false;
      this.showQuestion = false;
      this.$store.state.cl_task_uid = null;
      this.$store.state.cl_question_uid = null;
      this.$store.commit("set_selected_route");
    },
    questionClosedHandler: function (entry) {
      this.showQuestion = false;
      this.$store.state.cl_question_uid = null;
      this.$store.commit("set_selected_route");
    },
    dialogClosed: function (val) {
      this.showMachines = false;
    },
    appendTranslateCallback: function (f, v1, v2) {
      if (this[f][v1] && this[f][v1].length > 2) {
        this["field_message_" + v2] = [this.$t("LABEL122")];
        translateField(this[f][v1]).then((data) => {
          this["field_message_" + v2] = [];
          if (data.status == "success") {
            this[f][v2] = data.translations[0].text;
          }
        });
      }
    },
    changeMachines: function (val) {
      this.showMachines = false;
      this.answer_entry.machines = val.add_machines;
      this.answer_entry.remove_machines = val.remove_machines;

      if (val.group_uid) {
        // Es wurde eine neue Gruppe aus der Auswahl erstellt
        this.answer_entry.machinegroup_list = [val.group_uid];
      }
    },
    openMachinesDialog: function () {
      this.sel_addmachines = JSON.parse(
        JSON.stringify(this.answer_entry.machines)
      );
      this.sel_removemachines = JSON.parse(
        JSON.stringify(this.answer_entry.remove_machines)
      );
      this.showMachines = true;

      this.sel_machinesingroup = [];

      if (this.machinegroups) {
        for (let k of this.machinegroups) {
          if (this.answer_entry.machinegroup_list) {
            for (let m of this.answer_entry.machinegroup_list) {
              if (k.value == m) {
                this.sel_machinesingroup = this.sel_machinesingroup.concat(
                  JSON.parse(JSON.stringify(k.machines))
                );
              }
            }
          } else {
            if (k.value == this.answer_entry.machinegroup) {
              this.sel_machinesingroup = JSON.parse(JSON.stringify(k.machines));
              break;
            }
          }
        }
      }
    },
  },
  destroyed() {
    this.$store.state.searchField = false;
  },
  mounted() {
    this.$store.state.cl_uid = this.$route.params.uid;

    this.$store.state.searchField = true;

    this.$store.state.initParams = { ...this.$route.params };

    this.bc = new BroadcastChannel("checklist");
    this.bc.onmessage = (eventMessage) => {
      if (
        eventMessage.data &&
        eventMessage.data.type == "SELECT_COMP" &&
        eventMessage.data.cl_uid == this.$store.state.cl_uid
      ) {
        //console.log(eventMessage.data.comp_path)

        for (let mk = 1; mk < 7; mk++) {
          this.$store.state["cl_components_" + mk] = [];
        }

        this.$store.state.cl_component_map = [""];

        for (let mk = 0; mk < eventMessage.data.comp_path.length; mk++) {
          this.$store.state.cl_component_map.push(
            eventMessage.data.comp_path[mk].id
          );
        }

        this.$store.commit("set_selected_route");
        this.$store.state.initParams = { ...this.$route.params };
        EventBus.$emit("path_changed", {});
      } else if (
        eventMessage.data &&
        eventMessage.data.type == "COPY_ENTRY" &&
        eventMessage.data.cl_uid != this.$store.state.cl_uid
      ) {
        this.$store.state.copy_entry = eventMessage.data.entry;
      }
    };

    EventBus.$on("task_closed", this.taskClosedHandler);
    EventBus.$on("question_closed", this.questionClosedHandler);
    EventBus.$on("component_closed", this.componentClosedHandler);

    EventBus.$on("updateInformElement", this.updateInformElement);

    Rtc.subscribe("checklist-" + this.$store.state.cl_uid);
    Rtc.bind("overview", (data) => {
      //console.log("pusher refresh", data)
    });

    let ref = this;
    ref.searchContentHeight = window.innerHeight - 160;
    window.addEventListener("resize", function () {
      ref.searchContentHeight = window.innerHeight - 160;
    });

    //window.setTimeout(() => {
    //  this.prueferg = "";
    //}, 2000);

    getMessageFormats(this.$store.state.lang).then((resp) => {
      if (resp.status == "success") {
        this.$store.state.cl_message_formats = JSON.parse(JSON.stringify(resp.data.list));

    
        getChecklist(this.$store.state.lang, this.$store.state.cl_uid)
          .then((resp) => {
            if (resp.status == "success") {
              if (resp.data.checklist.length > 0) {
                this.$store.state.machines = resp.data.machines;
                this.$store.state.cl_machine_groups = resp.data.machine_groups;
                this.$store.state.cl_machine_groups.unshift({
                  text: "-",
                  value: "-1",
                  machines: [],
                });

                this.$store.state.projects = resp.data.projects;
                this.$store.state.inspection_types = resp.data.inspection_types;
                this.$store.state.users = resp.data.users;
                this.$store.state.checklist = resp.data.checklist[0];
                this.$store.state.headerTitle = this.$store.state.checklist.name;
                this.$store.state.userId = resp.data.user_uid;
                this.initLoaded = true;
                this.$store.state.cl_components_2 = [];
                this.$store.state.cl_components_3 = [];
                this.$store.state.cl_components_4 = [];
                this.$store.state.cl_components_5 = [];

                // Alle Komponenten auf der ersten Ebene laden
                getAllComponents(this.$store.state.cl_uid, this.$store.state.lang)
                  .then((resp) => {
                    if (resp.status == "success") {
                      console.log(resp.data);
                      this.showComponents = true;
                      this.$store.commit("cl_components", resp.data.list);
                    }
                  })
                  .catch((e) => {
                    this.$store.dispatch("api_error", e);
                  });
              } else {
                this.$router.push({ name: "checklists" });
              }
            }
          })
          .catch((e) => {
            this.$store.dispatch("api_error", e);
          });


      }
    });


  },
  computed: {
    appLang: function () {
      return this.$store.state.lang
    },
    onlyPV: function () {
      return this.$store.getters.userRole.db_region; //this.userRole.db_region == 'eso'
    },
    userRole: function () {
      if (this.$store.getters.userRole) {
        return this.$store.getters.userRole;
      }
      return {};
    },
    searchDrawer: {
      // getter
      get: function () {
        return this.$store.state.search_drawer;
      },
      // setter
      set: function (newValue) {
        //this.items_search = []
        //this.search_keyword = ""
        this.$store.state.search_drawer = newValue;
      },
    },
    filter_tree() {
      return this.caseSensitive
        ? (item, search, textKey) => item[textKey].indexOf(search) > -1
        : undefined;
    },
    selectedComponent: function () {
      return this.$store.state.cl_component_uid;
    },
    cld_components: function () {
      return this.$store.state.cl_components;
    },
    likesAllFruit() {
      return this.selectedFruits.length === this.fruits.length;
    },
    saving() {
      return this.$store.state.saving;
    },
    likesSomeFruit() {
      return this.selectedFruits.length > 0 && !this.likesAllFruit;
    },
    icon() {
      if (this.likesAllFruit) return "mdi-close-box";
      if (this.likesSomeFruit) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
    machinegroups() {
      return this.$store.state.cl_machine_groups;
    },
    projects() {
      return this.$store.state.projects;
    },
    machine_groups() {
      return this.$store.state.cl_machine_groups;
    },
    machines() {
      if (this.filter1 && this.filter1.length > 0) {
        return this.$store.state.machines.filter((machine) => {
          return (
            machine.text.toLowerCase().indexOf(this.filter1.toLowerCase()) !==
            -1
          );
        });
      }
      return this.$store.state.machines;
    },
    userInfoAnswer() {
      if (this.create_entry) {
        return this.$store.state.users[this.answer_entry.user_uid];
      }
      return "";
    },
  },
};
